import React from "react";
import { useDrag, useDrop } from "react-dnd";

const ItemTypes = {
  CARD: "CARD",
};

const DraggableWrapper = ({
  id,
  index,
  row,
  moveCard,
  children,
  isDragMode,
  onRemove,
}) => {
  const [{ isDragging }, drag] = useDrag({
    type: ItemTypes.CARD,
    item: { id, index, row },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
    canDrag: isDragMode,
  });

  const [, drop] = useDrop({
    accept: ItemTypes.CARD,
    hover: (item) => {
      if (!isDragMode) return;

      const dragIndex = item.index;
      const hoverIndex = index;

      const fromRow = item.row;
      const toRow = row;

      if (dragIndex === hoverIndex && fromRow === toRow) return;

      moveCard(fromRow, toRow, dragIndex, hoverIndex);

      // update dragged item
      item.index = hoverIndex;
      item.row = toRow;
    },
  });

  return (
    <div
      ref={(node) => drag(drop(node))}
      className={`relative h-full ${isDragMode ? "cursor-move" : ""}`}
      style={{ opacity: isDragging ? 0.5 : 1, height: "100%" }}
    >
      {isDragMode && onRemove && (
        <button
          onClick={() => onRemove(id)}
          className="absolute -top-2 -right-2 z-20 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center hover:bg-red-600 transition-colors shadow-lg"
        >
          ×
        </button>
      )}
      {children}
    </div>
  );
};

export default DraggableWrapper;
